module.exports = __webpack_public_path__ + "assets/img/DS-living dinning (8).d4fe047a.jpg";